module.exports = __webpack_public_path__ + "img/bianpao_des_2.a8ee48e0.jpg";